import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage} from "../BasePanelPage";
import {ChooseAddressComponent, getAddAddressLabel} from "./components/ChooseAddressComponent";
import {addressController} from "../../../inline-subscription/AddressController";
import {UserAddressStore} from "../../../../../client/state/UserAddressStore";
import {MerchantButton} from "../../../../common/MerchantButton";
import {Messages} from "../../../../Messages";
import {PanelToast} from "../../../PanelToast";
import {AddAddressComponent} from "./components/AddAddressComponent";
import {EditAddressComponent} from "./components/EditAddressComponent";
import {iFrameUserDataService} from "../../../../services/IFrameUserDataService";
import {Router} from "../../../../../stem-core/src/ui/Router";


export const ADDRESS_SECTION_STATE = {
    chooseAddress: "chooseAddress",
    addAddress: "addAddress",
    continueWithAddedAddress: "continueWithAddedAddress",
    editAddress: "editAddress",
};

const ADDRESS_SECTION_MAP = {
    [ADDRESS_SECTION_STATE.chooseAddress]: ChooseAddressComponent,
    [ADDRESS_SECTION_STATE.addAddress]: AddAddressComponent,
    [ADDRESS_SECTION_STATE.continueWithAddedAddress]: AddAddressComponent,
    [ADDRESS_SECTION_STATE.editAddress]: EditAddressComponent,
};

export class AddressPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: () => addressController.addressSectionState === ADDRESS_SECTION_STATE.chooseAddress ?
                Messages.chooseAddress : getAddAddressLabel(),
        };
    }

    getAddressSectionState() {
        if (!addressController.selectedAddress && !iFrameUserDataService.getExtraUserAddressCount()) {
            return ADDRESS_SECTION_STATE.continueWithAddedAddress;
        }
        return addressController.addressSectionState;
    }

    isButtonDisabled() {
        return !(this.addressComponent && this.addressComponent.isValid());
    }

    render() {
        if (!addressController.selectedAddress && addressController.addressSectionState !== ADDRESS_SECTION_STATE.addAddress) {
            const selectedAddress = UserAddressStore.all()[0];
            addressController.update({
                selectedAddress,
                addressSectionState: (selectedAddress || iFrameUserDataService.getExtraUserAddressCount()) ?
                    ADDRESS_SECTION_STATE.chooseAddress : ADDRESS_SECTION_STATE.continueWithAddedAddress,
            });
        }

        const {styleSheet} = this;
        const AddressComponent = ADDRESS_SECTION_MAP[this.getAddressSectionState()];
        const onAddNewAddress = () => {
            addressController.addressSectionState = ADDRESS_SECTION_STATE.addAddress;
            Router.updateURL();
        };

        const buttonLabelMap = {
            [ADDRESS_SECTION_STATE.chooseAddress]: addressController.continueLabel || Messages.confirmChooseAddress,
            [ADDRESS_SECTION_STATE.editAddress]: Messages.editAddress,
            [ADDRESS_SECTION_STATE.continueWithAddedAddress]: addressController.continueLabel || Messages.addNewAddress,
            [ADDRESS_SECTION_STATE.addAddress]: getAddAddressLabel(),
        }

        return [
            <AddressComponent ref="addressComponent" onChange={() => this.redraw()}
                              onAddNewAddress={onAddNewAddress}/>,
            <MerchantButton disabled={this.isButtonDisabled()} onClick={() => this.handlePrimaryButtonClick()}
                            testId="addressButton" className={styleSheet.button}>
                {buttonLabelMap[this.getAddressSectionState()]}
            </MerchantButton>,
            <div className={styleSheet.center}>
                <div className={styleSheet.secondaryButton} onClick={() => {
                    if (addressController.addressSectionState === ADDRESS_SECTION_STATE.addAddress) {
                        addressController.addressSectionState = ADDRESS_SECTION_STATE.chooseAddress;
                        Router.updateURL();
                    } else {
                        addressController.onSelectCancel();
                    }
                }}>
                    {Messages.back}
                </div>
            </div>,
        ];
    }

    async handlePrimaryButtonClick() {
        try {
            addressController.update({selectedAddress: await this.addressComponent.getAddress()});
            if (addressController.addressSectionState === ADDRESS_SECTION_STATE.addAddress) {
                addressController.addressSectionState = ADDRESS_SECTION_STATE.chooseAddress;
                Router.updateURL();
            } else {
                await addressController.onSelectSuccess();
            }
        } catch (error) {
            if (error) {
                PanelToast.showError(error.message);
            }
        }
    }

    onMount() {
        super.onMount();

        this.attachChangeListener(UserAddressStore, () => this.redraw());
    }
}
